import { Injectable, OnDestroy } from '@angular/core';
import { SignalRService } from '@app/services/signal-r/signal-r.service';
import { BehaviorSubject, combineLatestWith, Observable, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { ClientEvent } from '@app/facade-services/client-event/model/client-event';
import { defined } from '@app/fremework/functions';
import { BasicEvent } from '@app/facade-services/client-event/model/basic-event';
import { RaceViewService } from '@app/facade-services/race-view/race-view.service';
import { RaceView } from '@app/facade-services/race-view/model/race-view';

@Injectable({
  providedIn: 'root'
})
export class ClientEventFacadeService implements OnDestroy {
  private unsubscribe$ = new Subject<void>();
  private clientEvents: ClientEvent[] = [];

  private clientEventSubject = new BehaviorSubject<ClientEvent[]>(null);
  public clientEvent$: Observable<ClientEvent[]> = this.clientEventSubject.asObservable();

  constructor(private readonly signalRService: SignalRService,
              private readonly raceViewService: RaceViewService) {
  }

  public init() {
    this.signalRService.basicEvent$
      .pipe(takeUntil(this.unsubscribe$), filter((event) => defined(event)),
        combineLatestWith(this.raceViewService.selectRaceView(false, false, true, 'clientEventFacadeService')),
        map(([signalREvent, raceView]) => {
          if (!this.clientEvents.find(c => c.uniqueId === signalREvent.uniqueId)) {
            this.pushEvent(signalREvent);
          } else if (!this.clientEvents.find(c => c.uniqueId === raceView.hashCode)) {
            this.pushEvent(this.mapToBasicEvent(raceView));
          }
        })).subscribe();
  }

  private mapToBasicEvent(rv: RaceView): BasicEvent {
    return {
      timestamp: new Date().toLocaleTimeString(),
      eventType: 'ngrx',
      uniqueId: rv.hashCode,
      msg: rv.hashCode,
      data: rv
    };
  }

  private pushEvent(basicEvent: BasicEvent) {
    if (this.clientEvents.length > 50) {
      this.clientEvents.pop();
    }
    this.clientEvents.unshift({
      eventType: basicEvent.eventType,
      logoPath: basicEvent.eventType === 'SignalR' ? 'assets/images/signalr.png' : 'assets/images/ngrx.png',
      ...basicEvent
    });

    this.clientEventSubject.next(this.clientEvents);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
